import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import all translation files
import enCommon from './locales/en/common.json';
import daCommon from './locales/dk/common.json';
import esCommon from './locales/es/common.json';
import svCommon from './locales/sv/common.json';
import noCommon from './locales/no/common.json';

const resources = {
    en: {
        common: enCommon,
    },
    da: {
        common: daCommon,
    },
    es: {
        common: esCommon,
    },
    sv: {
        common: svCommon,
    },
    no: {
        common: noCommon,
    },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en', // default language
        fallbackLng: 'en',

        // Namespaces
        ns: ['common'],
        defaultNS: 'common',

        interpolation: {
            escapeValue: false, // React already safes from xss
        },

        // React options
        react: {
            useSuspense: false, // prevents issues with React Native
        }
    });

export default i18n;